import { render, staticRenderFns } from "./ProductModel.vue?vue&type=template&id=7dd9c43e&scoped=true&"
import script from "./ProductModel.vue?vue&type=script&lang=js&"
export * from "./ProductModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd9c43e",
  null
  
)

component.options.__file = "ProductModel.vue"
export default component.exports